// Phase 25 iter-7 — avatar client.
//
// Three-step upload:
//   1. POST /users/me/avatar/upload-url with content_length + content_type
//      → { upload_url, public_url, key, expires_at }
//   2. PUT direct to S3 with Content-Type + Content-Length matching the
//      values declared in step 1 (S3 enforces them).
//   3. PATCH /users/me/avatar with the public_url so User.avatar_url is set.

import {
  API_VERSION_PREFIX,
  type AvatarUploadUrlRequest,
  type AvatarUploadUrlResponse,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function requestAvatarUploadUrl(
  input: AvatarUploadUrlRequest,
): Promise<AvatarUploadUrlResponse> {
  const { data } = await apiClient.post<AvatarUploadUrlResponse>(
    `${API_VERSION_PREFIX}/users/me/avatar/upload-url`,
    input,
  );
  return data;
}

export async function setMyAvatar(avatar_url: string | null): Promise<void> {
  await apiClient.patch(`${API_VERSION_PREFIX}/users/me/avatar`, { avatar_url });
}

export async function clearMyAvatar(): Promise<void> {
  await apiClient.delete(`${API_VERSION_PREFIX}/users/me/avatar`);
}

export async function uploadAvatarToS3(
  uploadUrl: string,
  blob: Blob,
  contentType: string,
): Promise<void> {
  // The TypeError catch distinguishes a CORS / network failure (no HTTP
  // response reached the browser) from a 4xx/5xx returned by S3 — the two
  // surface very different actions to the user.
  let res: Response;
  try {
    res = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': contentType },
      body: blob,
    });
  } catch (err) {
    const msg = err instanceof Error ? err.message : 'unknown';
    throw new Error(
      `Non se puido subir a imaxe (rede/CORS): ${msg}. Comproba a conexión ou avisa ao operador.`,
    );
  }
  if (!res.ok) {
    let detail = '';
    try {
      detail = (await res.text()).slice(0, 200);
    } catch {
      /* ignore */
    }
    throw new Error(
      `Subida rexeitada por S3 (HTTP ${res.status}). ${detail ? `Detalle: ${detail}` : ''}`.trim(),
    );
  }
}
